import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useHistory, useParams } from "react-router-dom";
import SchemeModal from "./SchemeModal";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  readmoreBtn: {
    borderRadius: 100,
  },
  heading: {
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
  list: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const AccordionList = (props) => {
  const { data, type } = props;
  const { schemeCategory } = useParams();
  const history = useHistory();
  const [expanded, setExpanded] = React.useState();
  // console.log("accordion type", props);
  const classes = useStyles();
  const [modalData, setModalData] = React.useState();

  const openModal = (data) => {
    setModalData(data);
  };

  const handleChange = (index) => {
    setExpanded(index);
  };

  const handleNavigate = (data) => {
    if (type === "form") {
      return openModal(data);
    }
    if (schemeCategory) {
      openModal(data);
      // alert(`if ${schemeCategory}`);
    } else {
      // alert(`else ${schemeCategory}`);

      history.push(`/gramschemes/${data.title}`);
    }
  };

  return (
    <div className={classes.root}>
      {modalData && (
        <SchemeModal
          open={true}
          onClose={() => {
            setModalData();
          }}
          title={modalData.title}
          // data={modalData}
          id={modalData.id}
          type={type}
        />
      )}
      <List component={Paper} disablePadding className={classes.list}>
        {data?.map((acc, index) => {
          return (
            <React.Fragment key={index}>
              <ListItem button onClick={() => handleNavigate(acc, type)}>
                <ListItemText
                  primary={
                    <Typography className={classes.heading}>
                      {acc.title}
                    </Typography>
                  }
                />
                <ListItemIcon>
                  <ExpandMoreIcon />
                </ListItemIcon>
              </ListItem>

              <Divider />
            </React.Fragment>
          );
        })}
      </List>
      {/* {data?.map((acc, index) => {
        const isExpanded = expanded === index;
        return (
          <Accordion
            key={index}
            expanded={isExpanded}
            onChange={() => handleChange(index)}
            TransitionProps={{
              timeout: 0,
              unmountOnExit: true,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>{acc.title}</Typography>
            </AccordionSummary>
            {acc.data && isExpanded && (
              <AccordionDetails>
                <Typography>{acc.data}</Typography>
              </AccordionDetails>
            )}
            {acc.link && (
              <AccordionActions>
                <Button
                  color="primary"
                  variant="outlined"
                  // onClick={() =>
                  //   handleNavigate(
                  //     acc.link,
                  //     acc.external,
                  //     acc.download,
                  //     acc.title
                  //   )
                  // }
                  className={classes.readmoreBtn}
                >
                  {acc.linkTitle}
                </Button>
              </AccordionActions>
            )}
          </Accordion>
        );
      })} */}
    </div>
  );
};
export default AccordionList;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Accordion,
//   AccordionActions,
//   AccordionDetails,
//   AccordionSummary,
//   Button,
//   Divider,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   Typography,
// } from "@material-ui/core";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import { useHistory } from "react-router-dom";
// import SchemeModal from "./SchemeModal";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     [theme.breakpoints.down("md")]: {
//       backgroundColor: "white",
//     },
//   },
//   readmoreBtn: {
//     borderRadius: 100,
//   },
//   heading: {
//     fontSize: "1.2rem",
//     color: theme.palette.primary.main,
//     fontWeight: "bold",
//     [theme.breakpoints.down("md")]: {
//       fontSize: "1rem",
//     },
//   },
//   list: {
//     backgroundColor: theme.palette.background.paper,
//   },
// }));

// const AccordionList = (props) => {
//   const { data, type } = props;
//   const [expanded, setExpanded] = React.useState();
//   // console.log("accordion type", props);
//   const classes = useStyles();
//   const [modalData, setModalData] = React.useState();

//   const openModal = (data) => {
//     setModalData(data);
//   };

//   const handleChange = (index) => {
//     setExpanded(index);
//   };

//   return (
//     <div className={classes.root}>
//       {modalData && (
//         <SchemeModal
//           open={true}
//           onClose={() => {
//             setModalData();
//           }}
//           title={modalData.title}
//           // data={modalData}
//           id={modalData.id}
//           type={type}
//         />
//       )}
//       <List component={Paper} disablePadding className={classes.list}>
//         {data?.map((acc, index) => {
//           return (
//             <>
//               <ListItem button onClick={() => openModal(acc)}>
//                 <ListItemText
//                   primary={
//                     <Typography className={classes.heading}>
//                       {acc.title}
//                     </Typography>
//                   }
//                 />
//                 <ListItemIcon>
//                   <ExpandMoreIcon />
//                 </ListItemIcon>
//               </ListItem>

//               <Divider />
//             </>
//           );
//         })}
//       </List>
//       {data?.map((acc, index) => {
//         const isExpanded = expanded === index;
//         return (
//           <Accordion
//             key={index}
//             expanded={isExpanded}
//             onChange={() => handleChange(index)}
//             TransitionProps={{
//               timeout: 0,
//               unmountOnExit: true,
//             }}
//           >
//             <AccordionSummary
//               expandIcon={<ExpandMoreIcon />}
//               aria-controls="panel1a-content"
//               id="panel1a-header"
//             >
//               <Typography className={classes.heading}>{acc.title}</Typography>
//             </AccordionSummary>
//             {acc.data && isExpanded && (
//               <AccordionDetails>
//                 <Typography>{acc.data}</Typography>
//               </AccordionDetails>
//             )}
//             {acc.link && (
//               <AccordionActions>
//                 <Button
//                   color="primary"
//                   variant="outlined"
//                   // onClick={() =>
//                   //   handleNavigate(
//                   //     acc.link,
//                   //     acc.external,
//                   //     acc.download,
//                   //     acc.title
//                   //   )
//                   // }
//                   className={classes.readmoreBtn}
//                 >
//                   {acc.linkTitle}
//                 </Button>
//               </AccordionActions>
//             )}
//           </Accordion>
//         );
//       })}
//     </div>
//   );
// };
// export default AccordionList;
